import React from "react"
import "./Work.css"
import { useTranslation } from "react-i18next"

const Work = () => {

  const { t, i18n } = useTranslation()

  return (
    <section className="work-section">
      <div className="work-content">
        <h3 className="work-title">{t('home.call_to_action.title')}</h3>
        <p className="work-text">
          {t('home.call_to_action.text_line_1')}
          <br />
          {t('home.call_to_action.text_line_2')}
        </p>
        <a href="/contact" className="work-btn">
          {t('home.call_to_action.btn_contact')}
        </a>
      </div>
    </section>
  )
}

export default Work